import { useGlobalContext } from "../../context";
import "./hero.css";

const Hero = () => {
  const { theme } = useGlobalContext();
  return (
    <>
      <div className="heroContainer">
        <div className="heroText fadeLeft" style={{ animationDelay: "200ms" }}>
          <div className="heroFirstLine">
            <div className="hi">Hi!</div>
            <div className="im">I'm</div>
          </div>
          <div className="sonu floating" style={{ animationDelay: "800ms" }}>
            Sonu
          </div>
          <div className="bardai">Bardai</div>
        </div>
        <img
          src={process.env.PUBLIC_URL + "/scroll2.webp"}
          className={theme === "light" ? "scrollGIF negativeGIF" : "scrollGIF"}
          onClick={() => {
            document
              .getElementById("credContainer")
              .scrollIntoView({ behavior: "smooth" });
          }}
          alt="heroImg"
        />
        <img
          className="heroImg fadeRight"
          style={{ animationDelay: "100ms" }}
          src={process.env.PUBLIC_URL + "/img1.png"}
          alt="SonuBardai"
        />
      </div>
    </>
  );
};

export default Hero;
